// src/pages/PlannedRoutes.jsx
import React from "react";
import { RouteListPage } from "../components/RouteListPage";

import { t } from "../i18n";
export default function PlannedRoutes() {
  return (
    <RouteListPage
      status="DRAFT"
      eyebrow={t("planned.eyebrow")}
      title={t("planned.title")}
      lead={t("planned.lead")}
      detailPath="/optimized-route"
      emptyTitle={t("planned.empty_title")}
      emptyMessage={t("planned.empty_message")}
    />
  );
}
